import 'react';
import { Modal, ModalHeader, ModalTitle, ModalContent, Text, ModalFooter, Button } from '@bloobirds-it/flamingo-ui';
import { useMinimizableModals, useMinimizableModal } from '@bloobirds-it/hooks';
import { jsxs, jsx } from 'react/jsx-runtime';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".confirmCloseModal-module__content__oZ9GS {\n  margin-bottom: 32px;\n}\n\n.confirmCloseModal-module__content__oZ9GS > p:first-child {\n  margin-bottom: 8px;\n}\n";
var styles = {"_content":"confirmCloseModal-module__content__oZ9GS"};
styleInject(css_248z);

var ConfirmCloseModal = function ConfirmCloseModal() {
  var _useMinimizableModals = useMinimizableModals(),
    confirmationModal = _useMinimizableModals.confirmationModal;
  var open = confirmationModal.open,
    id = confirmationModal.id;
  var _useMinimizableModal = useMinimizableModal(id),
    closeModal = _useMinimizableModal.closeModal,
    type = _useMinimizableModal.type,
    cancelConfirmModal = _useMinimizableModal.cancelConfirmModal;
  var handleDelete = function handleDelete() {
    cancelConfirmModal();
    closeModal();
  };
  return /*#__PURE__*/jsxs(Modal, {
    width: 600,
    open: open,
    onClose: cancelConfirmModal,
    children: [/*#__PURE__*/jsx(ModalHeader, {
      children: /*#__PURE__*/jsx(ModalTitle, {
        children: "Close"
      })
    }), /*#__PURE__*/jsx(ModalContent, {
      children: /*#__PURE__*/jsxs("div", {
        className: styles._content,
        children: [/*#__PURE__*/jsxs(Text, {
          size: "m",
          children: ["You already filled some information on your new ", type === null || type === void 0 ? void 0 : type.toLowerCase()]
        }), /*#__PURE__*/jsxs(Text, {
          size: "m",
          children: [/*#__PURE__*/jsx("b", {
            children: "This action cannot be undone"
          }), ", are you sure you want to continue?"]
        })]
      })
    }), /*#__PURE__*/jsxs(ModalFooter, {
      children: [/*#__PURE__*/jsx(Button, {
        variant: "tertiary",
        onClick: cancelConfirmModal,
        children: "Cancel"
      }), /*#__PURE__*/jsx(Button, {
        variant: "primary",
        color: "tomato",
        dataTest: "deleteModalDeleteButton",
        onClick: handleDelete,
        children: "Discard"
      })]
    })]
  });
};

export { ConfirmCloseModal };
